import request from '@/API/request';

/*获取公司总量*/
export function getCompanyList(data) {
  return request({
    url: '/mapscp/api/company/all',
    method: 'get',
    params: data,
  });
}

/*获取公司每省top10*/
export function getCompanyTop10(data) {
  return request({
    url: '/mapscp/api/company/top',
    method: 'get',
    params: data,
  });
}

/*获取公司（仓库）及物资总数*/
export function getStoreCount(data) {
  return request({
    url: '/mapscp/api/company/count',
    method: 'get',
    params: data,
  });
}

/*获取区域下公司信息及仓库数*/
export function getAreaCount(data) {
  return request({
    url: '/mapscp/api/company/statistics',
    method: 'get',
    params: data,
  });
}

/*统计区域下公司仓库库存*/
export function getAreaStoreCount(data) {
  return request({
    url: '/mapscp/api/company/inventory/statistics',
    method: 'get',
    params: data,
  });
}

/*获取时间字典数据*/
export function getTimeDictionary(data) {
  return request({
    url: '/mapscp/api/category',
    method: 'get',
    params: data,
  });
}

// 地图二级撒点获取仓库-客户
export function getMapDataLevel2(data) {
  return request({
    url: '/mapscp/api/warehouse/map/level2',
    method: 'get',
    params: data,
  });
}


// 地图三级撒点获取仓库-客户
export function getMapDataLevel3(data) {
  return request({
    url: '/mapscp/api/warehouse/map/level3',
    method: 'get',
    params: data,
  });
}

// 获取仓库-客户储备排行
export function getStoreTop10(data) {
  return request({
    url: '/mapscp/api/warehouse/top',
    method: 'get',
    params: data,
  });
}

// 获取公司详情
export function getCompanyDetail(id) {
  return request({
    url: `/mapscp/api/company/${id}`,
    method: 'get',
  });
}

// 获取仓库-客户详情
export function getStoreDetail(id) {
  return request({
    url: `/mapscp/api/warehouse/${id}`,
    method: 'get',
  });
}


// 查询维度值列表
export function getPriceList(data) {
  return request({
    url: `/mapscp/api/dim-value`,
    method: 'get',
    params: data
  });
}

// 查询价格趋势
export function getPriceTrend(data) {
  return request({
    url: `/mapscp/api/price/trend`,
    method: 'get',
    params: data
  });
}

// 获取每省区域面积Top10
export function getServiceAreaTop10() {
  return request({
    url: `/mapscp/api/company/top/area`,
    method: 'get',
  });
}
